// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.5
//   protoc               v6.30.2
// source: pins.proto

/* eslint-disable */
import type { Empty } from "./google/protobuf/empty";

export const protobufPackage = "proto";

export interface PinReference {
  type: PinReference_Type;
  value: string | undefined;
}

export enum PinReference_Type {
  MANUAL = "MANUAL",
  DASHBOARD = "DASHBOARD",
  CONVERSATION = "CONVERSATION",
  CSAT_DASHBOARD = "CSAT_DASHBOARD",
  DISPUTES_DASHBOARD = "DISPUTES_DASHBOARD",
}

export interface PinUser {
  id: string;
  name: string;
  email: string;
  avatar: string | undefined;
}

export interface Pin {
  id: string;
  creator: PinUser | undefined;
  body: string;
  reference: PinReference | undefined;
  commentCount: number;
  lastCommentAt: string | undefined;
  participants: PinUser[];
  createdAt: string | undefined;
  updatedAt: string | undefined;
  unread: boolean;
  folderId: string;
}

export interface CreatePinPayload {
  userId: string;
  body: string;
  reference: PinReference | undefined;
}

export interface EditPinPayload {
  id: string;
  body: string;
  userId: string;
}

export interface EditPinResponse {
  folderId: string;
}

export interface PinUUIDPayload {
  id: string;
}

export interface PinParticipantPayload {
  pinId: string;
  userId: string;
}

export interface PinReferenceConversation {
  title: string;
  sourceType: string;
  createdAt: string | undefined;
}

export interface PinReferenceDashboard {
  workspaceName: string;
}

export interface PinReferenceManual {
  body: string;
  createdAt: string | undefined;
}

export interface PinReferenceResponse {
  conversation: PinReferenceConversation | undefined;
  dashboard: PinReferenceDashboard | undefined;
  manual: PinReferenceManual | undefined;
  csatDashboard: PinReferenceDashboard | undefined;
  disputesDashboard: PinReferenceDashboard | undefined;
}

export interface PinComment {
  id: string;
  user: PinUser | undefined;
  replies: PinComment[];
  body: string;
  createdAt: string | undefined;
  updatedAt: string | undefined;
}

export interface PinCommentsResponse {
  comments: PinComment[];
}

export interface CreatePinCommentPayload {
  pinId: string;
  parentId: string | undefined;
  body: string;
}

export interface EditPinCommentPayload {
  pinId: string;
  id: string;
  body: string;
}

export interface DeletePinCommentPayload {
  pinId: string;
  id: string;
}

export interface PinFolder {
  id: string;
  user: PinUser | undefined;
  totalPins: number;
  lastCreatedAt: string | undefined;
  lastUpdatedAt: string | undefined;
  unread: boolean;
}

export interface ListPinFoldersPayload {
  sort: ListPinFoldersPayload_SortField;
}

export enum ListPinFoldersPayload_SortField {
  ALPHABETICALLY = "ALPHABETICALLY",
  CREATED = "CREATED",
  UPDATED = "UPDATED",
  PINS = "PINS",
}

export interface PinFoldersResponse {
  folders: PinFolder[];
}

export interface GetPinsInFolderPayload {
  id: string;
  fromDate: string | undefined;
  toDate: string | undefined;
}

export interface GetPinsInFolderByUserPayload {
  id: string;
  fromDate: string | undefined;
  toDate: string | undefined;
}

export interface PinsInFolderResponse {
  folderUser: PinUser | undefined;
  pins: Pin[];
}

export interface SearchPinsPayload {
  query: string;
}

export interface SearchPinsMatch {
  folderId: string;
  pinId: string;
  commentId: string | undefined;
  user: PinUser | undefined;
  body: string;
}

export interface SearchPinsResponse {
  folders: PinFolder[];
  messages: SearchPinsMatch[];
}

export interface HasPinsForResponse {
  exists: boolean;
}

export interface UnreadPinsResponse {
  count: number;
}

export interface MarkPinsViewedPayload {
  ids: string[];
}

export interface CanSeePinRequest {
  pinId: string;
}

export interface CanSeePinResponse {
  canSee: boolean;
}

export interface AddPinParticipantsRequest {
  pinId: string;
  userIDs: string[];
}

export interface DeleteConversationPinsRequest {
  connectionId: string;
  externalTicketId: string;
}

export interface GetPinsRequest {
  pinIds: string[];
}

export interface GetPinsResponse {
  pins: Pin[];
}

export interface Pins {
  /** CreatePin creates a new pin to given folder - user only now */
  CreatePin(request: CreatePinPayload): Promise<Pin>;
  /** EditPin edits an existing pin */
  EditPin(request: EditPinPayload): Promise<EditPinResponse>;
  /** DeletePin deletes given pin */
  DeletePin(request: PinUUIDPayload): Promise<Empty>;
  /** SearchPins returns all matching pin folders and comments */
  SearchPins(request: SearchPinsPayload): Promise<SearchPinsResponse>;
  /** UnreadPinsCount returns count of unread pins */
  UnreadPinsCount(request: Empty): Promise<UnreadPinsResponse>;
  /** MarkPinsViewed marks given pins viewed */
  MarkPinsViewed(request: MarkPinsViewedPayload): Promise<Empty>;
  /** HasPinsFor returns true if there are pins for reference */
  HasPinsFor(request: PinReference): Promise<HasPinsForResponse>;
  /** AddPinParticipant adds participant to pin */
  AddPinParticipant(request: PinParticipantPayload): Promise<Empty>;
  /** RemovePinParticipant removes participant from pin */
  RemovePinParticipant(request: PinParticipantPayload): Promise<Empty>;
  /** GetPinReferencePreview returns extra metadata for pin reference */
  GetPinReferencePreview(request: PinReference): Promise<PinReferenceResponse>;
  /** GetPinComments returns all comments under the pin */
  GetPinComments(request: PinUUIDPayload): Promise<PinCommentsResponse>;
  /** CreatePinComment creates a new comment under pin */
  CreatePinComment(request: CreatePinCommentPayload): Promise<PinComment>;
  /** EditPinComment edits an existing pin comment */
  EditPinComment(request: EditPinCommentPayload): Promise<Empty>;
  /** DeletePinComment deletes given pin comment */
  DeletePinComment(request: DeletePinCommentPayload): Promise<Empty>;
  /** ListPinFolders returns pin folders */
  ListPinFolders(request: ListPinFoldersPayload): Promise<PinFoldersResponse>;
  /** GetPinsInFolder returns all pins in given folder */
  GetPinsInFolder(request: GetPinsInFolderPayload): Promise<PinsInFolderResponse>;
  /** GetPinsInFolderByUser returns all pins in given folder by linked user */
  GetPinsInFolderByUser(request: GetPinsInFolderByUserPayload): Promise<PinsInFolderResponse>;
}

export interface PinsInternal {
  CanSeePin(request: CanSeePinRequest): Promise<CanSeePinResponse>;
  AddPinParticipants(request: AddPinParticipantsRequest): Promise<Empty>;
  DeleteConversationPins(request: DeleteConversationPinsRequest): Promise<Empty>;
  GetPins(request: GetPinsRequest): Promise<GetPinsResponse>;
}
